import { render, staticRenderFns } from "./addFollow.vue?vue&type=template&id=924886ca&scoped=true&"
import script from "./addFollow.vue?vue&type=script&lang=js&"
export * from "./addFollow.vue?vue&type=script&lang=js&"
import style0 from "./addFollow.vue?vue&type=style&index=0&id=924886ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924886ca",
  null
  
)

export default component.exports